import { render, staticRenderFns } from "./fidelior-register.vue?vue&type=template&id=a21cef7c&"
import script from "./fidelior-register.vue?vue&type=script&lang=js&"
export * from "./fidelior-register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports